import React from "react";
import { Stack, Button, CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function LoadingMore({
  total,
  result,
  loading,
  onClick,
  message,
  moreBtnLink,
  moreBtnTitle,
}) {
  if (loading) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        p={4}
      >
        <CircularProgress />
      </Stack>
    );
  }
  if (total !== result) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        p={4}
      >
        <Button onClick={onClick}>نمایش بیشتر</Button>
      </Stack>
    );
  }
  if (result > 0) {
    return;
    // return (
    //   <Stack alignItems="center" justifyContent="center" width='100%' height='100%' p={4}>
    //     <Typography variant="caption">برای مشاهده نتایج بیشتر فیلترها را تغییر دهید</Typography>
    //   </Stack>
    // );
  }
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      p={4}
      rowGap={2}
    >
      <Typography variant="caption" color="text.secondary">
        موردی یافت نشد!
      </Typography>
      <Typography variant="subtitle1" color="text.disabled">
        {message}
      </Typography>
      {moreBtnLink && (
        <Button
          variant="outlined"
          color="secondary"
          LinkComponent={Link}
          to={moreBtnLink}
        >
          {moreBtnTitle}
        </Button>
      )}
    </Stack>
  );
}
